module.exports = __webpack_public_path__ + "static/img/fb.e34e765.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/common/fb.png
// module id = AgqH
// module chunks = 7